import { render } from "./Autocomplete.vue?vue&type=template&id=f3145a32&ts=true&lang=pug"
import script from "./Autocomplete.vue?vue&type=script&setup=true&lang=ts"
export * from "./Autocomplete.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__